import { Box, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { formatAmountInINR } from "jsFunctions/formatAmountInINR";

const TdsAmountTable = ({ editTdsData, currentTdsData, type }) => {

    return (

        type === 'current' ?
        <div className="info-table change-modal-table">

        <Table className="table-info">
          <Thead>
            <Tr>
              <Th>Base Amount</Th>
              <Th>TDS Percent</Th>
              <Th>TDS Amount</Th>
            </Tr>
          </Thead>
          <Tbody>
            {editTdsData?.map((item, index) => {
              return (
                <Tr>
                  <Td className={`${Number(item?.bsAmt || 0) !== Number(currentTdsData[index]?.bsAmt)  ? 'data_compare_red' : '' }`}><Box>{formatAmountInINR( parseFloat(item?.bsAmt || 0))}</Box></Td>
                  <Td className={`${Number(item?.prc || 0) !== Number(currentTdsData[index]?.prc)  ? 'data_compare_red' : '' }`}><Box>{item?.prc || 0} %</Box></Td>
                  <Td className={`${Number(item?.tlAmt || item?.tdsAmt || 0) !== Number(currentTdsData[index]?.tlAmt || currentTdsData[index]?.tdsAmt)  ? 'data_compare_red' : '' }`}><Box>{formatAmountInINR( parseFloat(item?.tlAmt || item?.tdsAmt || 0))}</Box></Td>
                </Tr> 
              );
            })}
          </Tbody>
        </Table>
      </div>
            :
            <div className="info-table change-modal-table">

                <Table className="table-info">
                    <Thead>
                        <Tr>
                            <Th>Base Amount</Th>
                            <Th>TDS Percent</Th>
                            <Th>TDS Amount</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {currentTdsData?.map((item, index) => {

                          return (
                            <Tr>
                               <Td className={`${Number(item?.bsAmt) !== Number(editTdsData[index]?.bsAmt || 0)  ? 'data_compare_green' : '' }`}><Box>{formatAmountInINR( parseFloat(item?.bsAmt || 0))}</Box></Td>
                              <Td className={`${Number(item?.prc) !== Number(editTdsData[index]?.prc || 0)  ? 'data_compare_green' : '' }`}><Box>{item?.prc || 0} %</Box></Td>
                              <Td className={`${Number(item?.tlAmt || item?.tdsAmt || 0) !== Number(editTdsData[index]?.tlAmt || editTdsData[index]?.tdsAmt || 0)  ? 'data_compare_green' : '' }`}><Box>{formatAmountInINR( parseFloat(item?.tlAmt || item?.tdsAmt || 0))}</Box></Td>
                            </Tr> 
                          );
                        })}
                      </Tbody>
                    </Table>
                  </div>

    )


}

export default TdsAmountTable;
